type UploadForm =
  | 'feedback-image'
  | 'business-document'
  | 'product-review-image';

const API_BASE = import.meta.env.VITE_UPLOAD_API

export async function uploadFile (
  form: UploadForm,
  file: File,
): Promise<{
  id: number;
  url: string;
}> {
  const url = `${API_BASE}/${form}/upload`

  const formData = new FormData()
  formData.append(form, file)

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error upload file: ${response.status} ${errorText}`)
  }

  return response.json()
}
